import EmojiConvertor from "emoji-js";
import ClassicExtension from "./ClassicExtension";

/**
 * Converts emoticons like :-) to emojis like 😊 in all textareas.
 * 
 * Add attribute `data-emoji-convert-disabled` to a textarea to disable conversion for that textarea.
 */

export default class EmojiConvertorExtension extends ClassicExtension {
    private readonly ec: EmojiConvertor;

    constructor() {
        super();
        this.ec = new EmojiConvertor();
        this.ec.replace_mode = 'unified';
    }

    protected override init($root: JQuery<HTMLElement>): void {
        $root.find('textarea').each((_, element) => {
            element.addEventListener('input', () => {
                this.handleEmojiRewrite(element);
            });
        });
    }

    private handleEmojiRewrite(element: HTMLTextAreaElement): void {
        if (document.activeElement !== element) {
            return;
        }

        if (element.hasAttribute('data-emoji-convert-disabled')) {
            return;
        }

        element.value = this.ec.replace_emoticons(element.value);
    }
}